export default __webpack_public_path__ + "static/media/Techion.0a8f0d1b.gif";